/* src/app/components/privacy/privacy.component.scss */
.folha {
  max-width: min(640px, 100vw);
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  min-height: calc(100vh - 5rem);
  box-shadow: 6px 6px 12px #222;
}
.folha h1 {
  font-size: 2.5rem;
  padding-top: 2rem;
  text-align: center;
  width: 100%;
}
h2 {
  font-size: 1.6rem;
  font-weight: 400;
  text-transform: uppercase;
  color: #252527;
  line-height: 1.18;
}
h1,
h2 {
  margin-top: 22px;
  margin-bottom: 11px;
  text-shadow: none;
}
p {
  font-size: 0.8rem;
  color: #151515;
  line-height: 1.444;
  text-transform: none;
}
div.content {
  padding: 30px;
}
sub {
  margin-left: 120px;
  font-style: italic;
}
/*# sourceMappingURL=privacy.component-WJ52TENY.css.map */
